// 약관 동의 항목/헬퍼 — 웹 동의화면·네이티브 동의화면·백엔드(REQUIRED_TERMS)와 1:1.
//  key 는 백엔드 auth.service REQUIRED_TERMS(terms/privacy/location/over14) + marketing 과 동일해야 함.

export const CONSENT_ITEMS = [
  { key: "terms", label: "이용약관 동의", required: true, doc: "terms" },
  { key: "privacy", label: "필수 개인정보 수집·이용 동의", required: true, doc: "privacyConsent" },
  { key: "contactSharing", label: "거래 상대방 개인정보 제공 동의", required: true, doc: "contactSharing" },
  { key: "location", label: "위치기반서비스 이용약관 동의", required: true, doc: "location" },
  { key: "over14", label: "만 14세 이상입니다", required: true },
  { key: "marketingEmail", label: "이메일 광고성 정보 수신", required: false },
  { key: "marketingSms", label: "SMS·알림톡 광고성 정보 수신", required: false },
  { key: "marketingPush", label: "앱 푸시 광고성 정보 수신", required: false },
];

export const REQUIRED_KEYS = CONSENT_ITEMS.filter((i) => i.required).map((i) => i.key);

export const isAllRequired = (agree) => REQUIRED_KEYS.every((k) => !!agree?.[k]);

// 체크 상태({terms:true,...}) → 백엔드 전송용 표준 객체
export const toAgreements = (checked) => ({
  terms: !!checked.terms,
  privacy: !!checked.privacy,
  contactSharing: !!checked.contactSharing,
  location: !!checked.location,
  over14: !!checked.over14,
  marketing: !!(checked.marketingEmail || checked.marketingSms || checked.marketingPush),
  marketingEmail: !!checked.marketingEmail,
  marketingSms: !!checked.marketingSms,
  marketingPush: !!checked.marketingPush,
  version: "2026-10-01",
});

// 동의 흐름 모드/캐리 저장 키
export const CONSENT_MODE_KEY = "muyeon.consentMode";          // 'signup' | 'gate'
export const SIGNUP_AGREEMENTS_KEY = "muyeon.signupAgreements"; // 가입 폼으로 넘길 동의값(JSON)

export const setConsentMode = (mode) => { try { sessionStorage.setItem(CONSENT_MODE_KEY, mode); } catch (e) {} };
export const getConsentMode = () => { try { return sessionStorage.getItem(CONSENT_MODE_KEY) || "signup"; } catch (e) { return "signup"; } };
export const stashSignupAgreements = (a) => { try { sessionStorage.setItem(SIGNUP_AGREEMENTS_KEY, JSON.stringify(a)); } catch (e) {} };
export const popSignupAgreements = () => {
  try {
    const v = sessionStorage.getItem(SIGNUP_AGREEMENTS_KEY);
    sessionStorage.removeItem(SIGNUP_AGREEMENTS_KEY);
    return v ? JSON.parse(v) : null;
  } catch (e) { return null; }
};
